'use client';

import { FC } from 'react';

import { Table } from '@ravago/shared/radiance/components/table/components/Table/Table';
import { TableBody } from '@ravago/shared/radiance/components/table/components/TableBody/TableBody';
import { TableCell } from '@ravago/shared/radiance/components/table/components/TableCell/TableCell';
import { TableHeader } from '@ravago/shared/radiance/components/table/components/TableHeader/TableHeader';
import { TableRow } from '@ravago/shared/radiance/components/table/components/TableRow/TableRow';
import { Typography } from '@ravago/shared/radiance/components/typography/components/Typography/Typography';
import { useTranslations } from '@ravago/shared/translations/client';

export interface ProductSpecificationSummary {
   name: string | null;
   providerName: string | null;
}

interface Props {
   specifications: ProductSpecificationSummary[];
}

export const ProductSpecifications: FC<Props> = ({ specifications }) => {
   const translate = useTranslations();

   if (!specifications.length) {
      return <Typography component="p">{translate('product.spec.no-specifications')}</Typography>;
   }

   return (
      <Table stroked="horizontal" tableLayout="fixed">
         <TableBody>
            {specifications.map((specification) => (
               <TableRow key={specification.name}>
                  <TableHeader>{specification.providerName ?? '-'}</TableHeader>
                  <TableCell>{specification.name ?? '-'}</TableCell>
               </TableRow>
            ))}
         </TableBody>
      </Table>
   );
};
